/**
 * @generated SignedSource<<c2ed1f587cbf95353ae1390d35c2a2d7>>
 * @relayHash dad029e1e98ea6d848c5aa71001009e1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 537f949487c4dfe9be09bab2ab9522b6bb0df65738a68a9f481b8154861f225d

import type { ConcreteRequest, Mutation } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraPublishIssueSearchConfigInput = {
  viewId: string;
};
export type JiraIssueSearchSettings = {
  groupBy?: string | null | undefined;
  hideDone?: boolean | null | undefined;
  hierarchyEnabled?: boolean | null | undefined;
};
export type SaveResetViewSettingsButtonUIPublishSettingsMutation$variables = {
  input: JiraPublishIssueSearchConfigInput;
  settings?: JiraIssueSearchSettings | null | undefined;
};
export type SaveResetViewSettingsButtonUIPublishSettingsMutation$data = {
  readonly jira_publishIssueSearchConfig: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly errorType: string | null | undefined;
        readonly statusCode: number | null | undefined;
      } | null | undefined;
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
    readonly view: {
      readonly " $fragmentSpreads": FragmentRefs<"SaveResetViewSettingsButtonCollapsible">;
    } | null | undefined;
  } | null | undefined;
};
export type SaveResetViewSettingsButtonUIPublishSettingsMutation = {
  response: SaveResetViewSettingsButtonUIPublishSettingsMutation$data;
  variables: SaveResetViewSettingsButtonUIPublishSettingsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "settings"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "message"
},
v4 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v5 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v6 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v7 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SaveResetViewSettingsButtonUIPublishSettingsMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraPublishIssueSearchConfigPayload",
        "kind": "LinkedField",
        "name": "jira_publishIssueSearchConfig",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "LinkedField",
            "name": "view",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "SaveResetViewSettingsButtonCollapsible"
              }
            ]
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SaveResetViewSettingsButtonUIPublishSettingsMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraPublishIssueSearchConfigPayload",
        "kind": "LinkedField",
        "name": "jira_publishIssueSearchConfig",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "LinkedField",
            "name": "view",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "canPublishViewConfig"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "savedViewId"
                  },
                  {
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "settings",
                        "variableName": "settings"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "isViewConfigModified"
                  }
                ],
                "type": "JiraIssueSearchViewMetadata",
                "abstractKey": "__isJiraIssueSearchViewMetadata"
              },
              (v7/*: any*/)
            ]
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v7/*: any*/)
                    ],
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "537f949487c4dfe9be09bab2ab9522b6bb0df65738a68a9f481b8154861f225d",
    "metadata": {},
    "name": "SaveResetViewSettingsButtonUIPublishSettingsMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "a6671d06b56b9b40ca645794973be28f";

export default node;
